<template>
    <div :class="['spacing-container', currentStyle]" :style="cssVars">
    </div>
</template>

<script>
export default {
    name: 'SpacingView',
    props: {
        currentStyle: {
            type: String,
            default: () => ''
        },
        value: {
            type: Object,
            default: () => {}
        }
    },
    computed: {
        cssVars() {
            return {
                '--height': this.value.height + 'px',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.spacing-container {
    width: 100%;
    overflow-y: hidden;
    height: var(--height);

    &.style1 {
        // 基础样式
    }
}
</style>